import * as React from "react";
import clsx from "clsx";
import { Building2 } from "lucide-react";
import type { OrgContextOrganization } from "../../lib/organization-context/types";
import { normalizeAvatarUrl } from "../../lib/profile-avatar-image";
import * as s from "./OrgContext.css";

export interface OrgLogoStackProps {
  orgs: OrgContextOrganization[];
  size?: "sm" | "md";
  maxVisible?: number;
}

export function OrgLogoStack({
  orgs,
  size = "sm",
  maxVisible = 3,
}: OrgLogoStackProps) {
  if (orgs.length === 0) return null;

  const visible = orgs.slice(0, maxVisible);
  const overflow = orgs.length - visible.length;

  return (
    <div className={s.logoStack} aria-hidden>
      {visible.map((org) => (
        <div
          key={org.id}
          className={clsx(s.logoStackItem, size === "md" && s.logoStackItemLarge)}
          title={org.name}
        >
          {org.logoUrl ? (
            <img
              src={normalizeAvatarUrl(org.logoUrl) ?? org.logoUrl}
              alt=""
              className={s.logoStackImg}
            />
          ) : (
            <Building2 size={size === "md" ? 13 : 11} strokeWidth={2} />
          )}
        </div>
      ))}
      {overflow > 0 && (
        <div
          className={clsx(s.logoStackItem, size === "md" && s.logoStackItemLarge)}
          title={`${overflow} more`}
        >
          <span className={s.logoStackOverflow}>+{overflow}</span>
        </div>
      )}
    </div>
  );
}
